
import PropTypes from 'prop-types';
import React from 'react';
import { Spin } from 'antd';
import { Button, Modal } from 'react-bootstrap';

import TextInput from '../../common/TextInput';

const TariffGroupModal = ({ authenticationState, commonState, onChange, saveTariffGroup, tariffGroupModalObj, toggle }) => {
    return (
        <Modal show={tariffGroupModalObj.show} onHide={toggle}>
            <Modal.Header closeButton>
                <Modal.Title>Gruppo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <TextInput
                    label="Codice Gruppo"
                    name="code"
                    required
                    onChange={onChange}
                    value={tariffGroupModalObj.tariffGroup.code} />
                <TextInput
                    label="Nome Gruppo"
                    name="name"
                    required
                    onChange={onChange}
                    value={tariffGroupModalObj.tariffGroup.name} />
            </Modal.Body>
            <Modal.Footer>
                <Spin spinning={commonState.blocking > 0} size="large" >
                    <Button bsStyle="success" onClick={saveTariffGroup}>Salva</Button>
                    <Button bsStyle="warning" onClick={toggle}>Chiudi</Button>
                </Spin>
            </Modal.Footer>
        </Modal>
    );
};

TariffGroupModal.propTypes = {
    authenticationState: PropTypes.object.isRequired,
    commonState: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    tariffGroupModalObj: PropTypes.object.isRequired,
    saveTariffGroup: PropTypes.func.isRequired,
    toggle: PropTypes.func.isRequired
};

export default TariffGroupModal;
